//공장관리자 컬럼 정의
export const _plantManagerColumns = [
  {
    field: "yearMonth",
    headerName: "날짜",
    width: 130,
    valueFormatter: (params) => {
      const value = params.value;
      return value ? `${value.substring(0, 4)}.${value.substring(4)}` : "";
    },
  },
  {
    field: "engId",
    headerName: "에너지종류",
    width: 130,
    valueFormatter: (params) => {
      const value = params.value;
      let engName = "";
      switch (value) {
        case "AIR":
          engName = "압축공기";
          break;
        case "STEAM":
          engName = "스팀";
          break;
        case "COOLWATER":
          engName = "냉수";
          break;
          case "EPWR":
          engName = "전기";    
          break;  
        default:
          engName = value;
      }
      return engName;
    },
  },
  {
    field: "method",
    headerName: "사용/공급",
    width: 130,
    valueFormatter: (params) => {
      const value = params.value;
      let name = "";
      switch (value) {
        case "cons":
          name = "사용";
          break;
        case "prod":
          name = "공급";
          break;
        default:
          name = value;
      }
      return name;
    },
  },
  {
    field: "engUnit",
    headerName: "단위",
    width: 130,
  },
  {
    field: "complexInloName",
    headerName: "산업단지명",
    width: 130,
  },
  {
    field: "companyInloName",
    headerName: "회사명",
    width: 130,
    // valueGetter: getFullName,
  },
  {
    field: "plantInloName",
    headerName: "사업장명",
    width: 130,
  },
  {
    field: "sumAmt",
    headerName: "월간사용량",
    width: 130,
    valueFormatter: (params) => {
      return new Intl.NumberFormat("ko-KR").format(params.value);
    },
  },
];

//산단관리자 컬럼 정의
export const _complexManagerColumns = [
  {
    field: "yearMonth",
    headerName: "날짜",
    width: 120,
    valueFormatter: (params) => {
      const value = params.value;
      return value ? `${value.substring(0, 4)}.${value.substring(4)}` : "";
    },
  },
  {
    field: "engId",
    headerName: "에너지종류",
    width: 120,
    valueFormatter: (params) => {
      const value = params.value;
      let engName = "";
      switch (value) {
        case "AIR":
          engName = "압축공기";
          break;
        case "STEAM":
          engName = "스팀";
          break;
        case "COOLWATER":
          engName = "냉수";
          break;
        default:
          engName = value;
      }
      return engName;
    },
  },
  {
    field: "method",
    headerName: "사용/공급",
    width: 100,
    valueFormatter: (params) => {
      const value = params.value;
      let name = "";
      switch (value) {
        case "cons":
          name = "사용";
          break;
        case "prod":
          name = "공급";
          break;
        default:
          name = value;
      }
      return name;
    },
  },
  { field: "engUnit", headerName: "단위", width: 100 },
  { field: "complexInloName", headerName: "산업단지명", width: 120 },
  // column 자체에 산단에 해당하는 공장 리스트 추가하기
  {
    field: "sumAmt",
    headerName: "합계",
    width: 120,
    valueFormatter: (params) => {
      // return new Intl.NumberFormat("ko-KR").format(params.value);
      return new Intl.NumberFormat("ko-KR").format(Math.round(params.value));
    },
  },
  // 해당 산단에 해당하는 공장들의 일자별 합계
];

export const managerColumns = (columns) => {
  return columns.map((column) => ({
    ...column,
    headerClassName: "DataGridHeader",
  }));
};

export const plantColumns = managerColumns(_plantManagerColumns);
export const complexColumns = managerColumns(_complexManagerColumns);

// 날짜 차이 계산 함수
export const getMonthBetween = (d1, d2) => {
  const year1 = parseInt(d1?.substr(0, 4));
  const month1 = parseInt(d1?.substr(4, 2));
  const year2 = parseInt(d2?.substr(0, 4));
  const month2 = parseInt(d2?.substr(4, 2));

  const monthDiff = (year2 - year1) * 12 + (month2 - month1);
  console.log("monthDiff >>>", monthDiff);

  return monthDiff;
};
